import { render } from "./WeeklyOrderSummary.vue?vue&type=template&id=018b0a15"
import script from "./WeeklyOrderSummary.vue?vue&type=script&lang=ts"
export * from "./WeeklyOrderSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script